// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eea08df9","355":"15829009","455":"1e121a05","977":"f5884555"}[chunkId] + ".chunk.js";
};